import { useEffect, useState } from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';
import { ToTopButton } from '../../Buttons';

function Content({ children, centerContent = false, className }) {
  let [isTest, useIsTest] = useState(false);

  useEffect(() => {
    useIsTest(process.env.REACT_APP_IS_TEST === 'true');
  }, [process.env.IS_TEST]);
  return (
    <>
      <div
        className={cn(
          styles.content,
          centerContent && styles.center_content,
          isTest && styles.test_background,
          className,
        )}
      >
        {children}
      </div>
      <ToTopButton />
    </>
  );
}

export default Content;
